import * as React from "react";
const SvgCategories = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <g fill="#082B60" clipPath="url(#categories_svg__a)">
      <path d="M23.337-.001h-2.66c-3.052 0-4.662 1.61-4.662 4.662v2.66c0 3.052 1.61 4.662 4.662 4.662h2.66c3.052 0 4.662-1.61 4.662-4.662V4.66c0-3.052-1.61-4.662-4.662-4.662M7.336 16h-2.66C1.61 16 0 17.61 0 20.662v2.66c0 3.066 1.61 4.676 4.662 4.676h2.66c3.052 0 4.662-1.61 4.662-4.662v-2.66C11.998 17.61 10.388 16 7.336 16M6.006 12.01A6.006 6.006 0 1 0 6.006 0a6.006 6.006 0 0 0 0 12.012M21.994 28.001a6.006 6.006 0 1 0 0-12.012 6.006 6.006 0 0 0 0 12.012" />
    </g>
    <defs>
      <clipPath id="categories_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCategories;
